import * as ss from 'superstruct';
import { Id } from '../../types';
import { TrackingQueryParamKey } from './tracking-query-param.type';
import { AdSources } from './paid-source.resource';

export const TrackCampaignId = 'Campaign ID';
export const TrackAccountId = 'Account ID';
/** Param whose mere presence implies the channel. */
export const TrackChannel = 'Channel';

/**
 * Set custom tracking parameters.  We'll process page loads for these and use them
 * when attributing conversions.
 */
export const CustomTrackingParamResource = ss.object({
  id: Id,

  /** Query param to track.  Unique per org. */
  param: ss.string(),

  /** Which ad source to associate with this custom tracking param. */
  adSource: ss.enums(AdSources),

  /** What this custom param represents - a known tracking query param key
   * or a generic concept like Campaign ID. */
  represents: ss.union([
    TrackingQueryParamKey,
    ss.literal(TrackCampaignId),
    ss.literal(TrackAccountId),
    ss.literal(TrackChannel),
  ]),
});

export type CustomTrackingParamResource = ss.Infer<
  typeof CustomTrackingParamResource
>;
